export const MESSAGE_TYPES = {
  TOURNAMENT_INVITATION: 'tournament_invitation',
  SYSTEM_NOTIFICATION: 'system_notification',
  EMAIL_STATUS: 'email_status',
  TOURNAMENT_UPDATE: 'tournament_update',
} as const;

export type MessageType = typeof MESSAGE_TYPES[keyof typeof MESSAGE_TYPES];
